import React from 'react';
import { useAppSelector } from '../../hooks/hooks';
import { Check, Info } from '../Helpers/icons/Icons';

const Alerts = () => {
  const alerts = useAppSelector((state) => state.alerts.alerts);

  return (
    <div className='toast-container' role='status' aria-live='polite'>
      {alerts?.length > 0 &&
        alerts.map((item) => (
          <div
            key={item.id}
            className={`alert flex w-full items-start gap-3 rounded-xl px-4 py-3 text-[14px] shadow-pop ${
              item.success ? 'bg-ink-900 text-paper' : 'bg-danger text-white'
            }`}
          >
            <span className={`mt-0.5 flex-none ${item.success ? 'text-apricot-400' : ''}`}>
              {item.success ? <Check size={17} /> : <Info size={17} />}
            </span>
            <span className='leading-snug'>{item.message}</span>
          </div>
        ))}
    </div>
  );
};

export default Alerts;
